<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Manage action categories and sub-categories. Configure visibility rules and access controls for different category types.
    </p>
    <div class="adf-hero-stats" *ngIf="isConfigurationReady && categoryList?.length">
      <div class="adf-stat">
        <span class="adf-stat-value">{{ categoryList.length }}</span>
        <span class="adf-stat-label">Categories</span>
      </div>
      <div class="adf-stat">
        <span class="adf-stat-value">{{ pagination.total || 0 }}</span>
        <span class="adf-stat-label">Rules</span>
      </div>
    </div>
  </div>

  <div class="adf-loader" *ngIf="!isConfigurationReady">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <div class="adf-content" *ngIf="isConfigurationReady">
    <div class="adf-control-bar">
      <div class="adf-control-bar-main">
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="openCategoryModal()">
          New {{ viewMode === 'basic' ? 'Category' : 'Rule' }}
        </button>

        <div class="adf-control-divider" aria-hidden="true"></div>

        <div class="adf-view-toggle" role="tablist" aria-label="View mode">
          <button type="button" role="tab" class="adf-toggle-btn"
            [class.active]="viewMode === 'basic'"
            [attr.aria-selected]="viewMode === 'basic'"
            (click)="setViewMode('basic')">Categories</button>
          <button type="button" role="tab" class="adf-toggle-btn"
            [class.active]="viewMode === 'advanced'"
            [attr.aria-selected]="viewMode === 'advanced'"
            (click)="setViewMode('advanced')">Rules</button>
        </div>
      </div>

      <div class="adf-control-bar-tools">
        <div class="adf-search">
          <span class="adf-search-icon" aria-hidden="true">
            <svg class="icon-set">
              <use [attr.xlink:href]="'./assets/images/icons.svg#search'"></use>
            </svg>
          </span>
          <input type="text" class="adf-search-input"
            [placeholder]="viewMode === 'basic' ? 'Search categories…' : 'Search rules…'"
            [(ngModel)]="searchText" (input)="onSearchChange()" (keyup)="onSearchChange()"
            [disabled]="!categoryList || categoryList.length === 0">
        </div>

        <div class="adf-paging" *ngIf="viewMode === 'advanced'">
          <button type="button" [disabled]="!pagingButtons.isFirst" (click)="paginateRulesList('first')" title="First">
            <img src="assets/images/chevron-double-left.svg" alt="" />
          </button>
          <button type="button" [disabled]="!pagingButtons.isPrevious" (click)="paginateRulesList('previous')" title="Previous">
            <img src="assets/images/chevron-left.svg" alt="" />
          </button>
          <span [class.disabled]="pagination.total <= 0">
            {{ pagination.pageFrom }}–{{ pagination.pageTo }} / {{ pagination.total }}
          </span>
          <button type="button" [disabled]="!pagingButtons.isNext" (click)="paginateRulesList('next')" title="Next">
            <img src="assets/images/chevron-right.svg" alt="" />
          </button>
          <button type="button" [disabled]="!pagingButtons.isLast" (click)="paginateRulesList('last')" title="Last">
            <img src="assets/images/chevron-double-right.svg" alt="" />
          </button>
        </div>
      </div>
    </div>

    <div class="adf-info-banner" *ngIf="viewMode === 'advanced'">
      <div class="adf-info-banner-body">
        <span class="adf-info-dot" aria-hidden="true"></span>
        <span>
          By default, all Categories are <strong>Visible</strong>. Rules here restrict visibility.
        </span>
      </div>
      <button type="button" class="adf-icon-btn" (click)="closeBanner()" title="Dismiss">
        <svg class="icon-set">
          <use [attr.xlink:href]="'./assets/images/icons.svg#close'"></use>
        </svg>
      </button>
    </div>

    <!-- Basic View -->
    <div class="adf-fields" *ngIf="viewMode === 'basic'">
      <div *ngIf="!categoryList?.length" class="adf-empty">
        <div class="adf-empty-visual" aria-hidden="true">
          <span></span><span></span><span></span>
        </div>
        <div class="adf-empty-title">Start with a category</div>
        <div class="adf-empty-text">Create a category, then add sub-categories under it.</div>
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="openCategoryModal()">
          New Category
        </button>
      </div>

      <div class="adf-groups" *ngIf="categoryList?.length">
        <article class="adf-group" *ngFor="let category of categoryList; let gi = index">
          <header class="adf-group-header">
            <div class="adf-group-header-left">
              <span class="adf-index" aria-hidden="true">{{ gi + 1 }}</span>
              <div class="adf-group-meta">
                <h3 class="adf-group-title">{{ category.name }}</h3>
                <span class="adf-group-count">
                  {{ category.children?.length || 0 }} sub-categor{{ (category.children?.length || 0) === 1 ? 'y' : 'ies' }}
                </span>
              </div>
            </div>
            <div class="adf-group-actions">
              <button type="button" [disabled]="readonly" class="adf-icon-btn" (click)="editCategory(category)" title="Edit">
                <svg class="icon-set">
                  <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
                </svg>
              </button>
              <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteCategory(category)" title="Delete">
                <svg class="icon-set">
                  <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                </svg>
              </button>
            </div>
          </header>

          <div class="adf-group-body">
            <div class="adf-children">
              <div class="adf-child" *ngFor="let subcategory of category.children; let ci = index">
                <div class="adf-child-row">
                  <div class="adf-child-left">
                    <span class="adf-child-index" aria-hidden="true">{{ ci + 1 }}</span>
                    <span class="adf-child-name">{{ subcategory.name }}</span>
                  </div>
                  <div class="adf-child-actions">
                    <button type="button" [disabled]="readonly" class="adf-icon-btn" (click)="editSubCategory(subcategory)" title="Edit">
                      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
                      </svg>
                    </button>
                    <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteCategory(subcategory)" title="Delete">
                      <svg class="icon-set">
                        <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <div class="adf-children-empty" *ngIf="!category.children?.length">
                No sub-categories in this category yet.
              </div>
            </div>

            <button type="button" [disabled]="readonly" class="adf-add-field" (click)="openSubCategoryModal(category.uuid)">
              Add New Sub-Category
            </button>
          </div>
        </article>
      </div>
    </div>

    <!-- Advanced View -->
    <div class="adf-rules" *ngIf="viewMode === 'advanced'">
      <div class="adf-rules-list" *ngIf="categoryRules?.length">
        <div class="adf-rule-card" *ngFor="let rule of categoryRules">
          <div class="adf-rule-main">
            <div class="adf-rule-title-row">
              <h4 class="adf-rule-name">{{ rule.name }}</h4>
              <span class="adf-status-pill" [class.is-on]="rule.is_enabled" [class.is-off]="!rule.is_enabled">
                {{ rule.is_enabled ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="adf-rule-meta">
              <span class="adf-rule-meta-text">Created : {{ rule.formatted_created_date }}</span>
              <span class="adf-meta-dot" aria-hidden="true"></span>
              <span class="adf-rule-meta-text">Updated : {{ rule.formatted_last_updated }}</span>
            </div>
          </div>
          <div class="adf-rule-side">
            <label class="adf-switch" title="Toggle active">
              <input type="checkbox" [disabled]="readonly" [checked]="rule.is_enabled" (change)="toggleRule(rule)">
              <span class="adf-switch-slider"></span>
            </label>
            <button type="button" class="adf-icon-btn" (click)="editRule(rule)" title="Edit rule">
              <svg class="icon-set">
                <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
              </svg>
            </button>
            <button type="button" [disabled]="readonly" class="adf-icon-btn adf-icon-btn--danger" (click)="deleteRule(rule)" title="Delete rule">
              <svg class="icon-set">
                <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="adf-empty" *ngIf="!categoryRules?.length">
        <div class="adf-empty-visual adf-empty-visual--rules" aria-hidden="true">
          <span></span><span></span>
        </div>
        <div class="adf-empty-title">No rules yet</div>
        <div class="adf-empty-text">Create a rule to restrict category visibility.</div>
        <button type="button" [disabled]="readonly" class="adf-btn adf-btn--primary" (click)="openCategoryModal()">
          New Rule
        </button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isModalOpen" (click)="closeCategoryModal()"></div>
  <aside class="right-modal" *ngIf="isModalOpen" [class.open]="isModalOpen" aria-modal="true" role="dialog">
    <dynamic-action-form-renderer [readonly]="readonly" [schema]="modalSchema" [data]="defaultValues" (submit)="submitForm($event)"
      (close)="closeCategoryModal()">
    </dynamic-action-form-renderer>
  </aside>
</div>
